import {
  monitoring_show_support_case_path,
  monitoring_create_support_case_path,
  monitoring_update_support_case_status_path,
  indicator_value_show_path,
  indicator_value_show_activity_path,
  support_request_update_status_path,
  monitoring_dashboard_phase_progress_data_path,
  monitoring_dashboard_call_status_data_path,
  result_framework_show_path,
  project_milestone_list_path,
  list_project_files_path,
  monitoring_project_info_path,
  programme_form_show_path,
  monitoring_info_path,
  monitoring_edit_indicator_value_path,
  monitoring_update_indicator_value_date_path
} from '~/routes';

export const Monitoring = {
  callProjectTable: null,
  callStatusChart: null,
  phaseProgressChart: null,
  simplePieChart: null,


  new: function(){
    jQuery('.select2').select2();
  },


  work_plan: function () {
    var container = jQuery('.content.work-plan');
    container.load(container.data('url'));
  },


  list_legacy: function() {
    if (!jQuery.fn.DataTable.isDataTable('table.monitoring-projects')) {
      var hiddenColumnsSetting = jQuery('table.monitoring-projects').data('hidden-columns-setting')
      var columns = [
        {
          mRender: function (data, type, rowData) {
            if (type == 'display') {
              return jQuery('#project-title-template').html().
                replace(/__id__/g, data.id).
                replace(/__label__/g, data.label);
            }
            return data.label;
          },
          width: '120px',
          name: 'project_id',
          aTargets: ['column-project_id']
        },
        {
          mRender: function (data, type, rowData) {
            if (type == 'display') {
              if (data.calculating) {
                return I18n.t('calculating') + '...';
              } else {
                return jQuery('#project-progress-template').html()
                  .replace(/__progress__/g, data.progress)
                  .replace(/__danger__/g, data.behind_schedule ? 'danger' : '')
                  .replace(/__invalid__/g, data.invalid_configuration ? 'invalid' : '')
                  .replace(/__no_data__/g, data.progress == null ? 'no-data' : '');
              }
            }
            if (data.calculating) {
              return -1;
            }
            return data.progress;
          },
          width: '240px',
          name: 'progress',
          aTargets: ['column-progress']
        },
        {
          mRender: function (data, type, rowData) {
            var str = '';
            Object.keys(data.total).forEach(function (currency) {
              str += data.paid[currency] + ' / ' + data.total[currency]
              if (currency != 'none') str += ' ' + currency.toUpperCase();
              str += '<br>'
            });

            return str;
          },
          width: '180px',
          name: 'payments',
          aTargets: ['column-payments']
        },
        {
          visible: false,
          targets: ActionJS.Monitoring.priv.getHiddenColumns()
        },
        {
          render: function (data, type, rowData) {
            if(data){
              return type == 'display' ? data.label : data.order
            }else{
              return null
            }
          },
          targets: jQuery('table.monitoring-projects').data('variable-columns')
        },

      ].filter(function(col){return hiddenColumnsSetting.indexOf(col['name']) == -1 })

      var options = {
        serverSide: true,
        ajax: {
            url: jQuery('table.monitoring-projects').data('url'),
            type: 'POST',
            dataSrc: function (json) {
              if (json.data.length > 0) {
                var data = [];
                for (var i = 0; i < json.data.length; i++) {
                  data.push(json.data[i]) ;
                }
                return data
              } else
                return json.data
          }
        },
        aaSorting: [[0, 'asc']],
        info: true,
        scrollX: true,
        lengthChange: false,
        language: {
          searchPlaceholder: I18n.t('search')
        },
        pageLength: 20,
        autoWidth: false,
        aoColumnDefs: columns,
        processing: true,
        drawCallback: function(settings) {
          DataTablesHelper.addColumnFilters(this);
          DataTablesHelper.addColumnSearchFields(this);
          //console.log("Draw")
          jQuery('div.danger, div.invalid').tooltip({
            title: function () {
              var title = "";
              if (a = jQuery(this).hasClass('invalid')) {
                title += (jQuery(this).attr('data-invalid-title') + "\n\n")
              }
              if (b = jQuery(this).hasClass('danger')) {
                title += jQuery(this).attr('data-danger-title') + "\n\n"
              }
              if (a || b) {
                title += I18n.t('click_for_more_details')
              }
              return title;
            }
          });
        },
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        }
      };
      
      ActionJS.Monitoring.priv.projectTable = jQuery('table.monitoring-projects').DataTable(options);
      DataTablesHelper.searchDelay(ActionJS.Monitoring.priv.projectTable, 1000);
      
    }
    
    // Columns selector
    jQuery('.dropdown.variable-columns').on('click', 'input, label', ActionJS.Monitoring.priv.updateVisibleColumns);
  },


  fact_sheet: function() {
    var container = jQuery('.content.fact-sheet');
    container.load(container.data('url'));
  },


  // Called from the partial
  _fact_sheet: function() {
    //TODO    ReactRailsUJS.mountComponents();
    this._init_fact_sheet_links();

    // Version list
    jQuery('.fact-sheet-versions tr:not(.selected)').on('click', function() {
      ActionJS.Monitoring._load_fact_sheet_content(this.getAttribute('data-url'));
    });

    // Delete
    jQuery('a.delete-fact-sheet').on('click', function() {
      var link = jQuery(this);
      if (confirm(link.attr('data-confirm'))) {
        jQuery.post(link.attr('href'), function() {
          Turbo.visit(location.href, {action: 'replace'});
        });
      }
      return false;
    });
  },

  _fact_sheet_edit: function () {
//TODO    ReactRailsUJS.mountComponents();
    this._init_fact_sheet_links();

    jQuery('#discard-autosave').on('click', function(e) {
      var url = jQuery(this).attr('href');
      url = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autosave=false';
      ActionJS.Monitoring._load_fact_sheet_content(url);
      return false;
    });

    AdaliaForm.init('.content.fact-sheet');
  },

  _load_fact_sheet_content: function(url) {
    var container = jQuery('.content.fact-sheet');
    SmartME.setLoadingIndicator(container, {overlay: true});
    container.load(url);
  },

  _init_fact_sheet_links: function() {
    jQuery('a.fact-sheet-link').on('click', function() {
      ActionJS.Monitoring._load_fact_sheet_content(this.href);
      return false;
    });
  },


  programme_progress: function () {
    var container = jQuery('.progress-container');
    container.load(container.data('url'));
  },


  indicators: function() {
    var container = jQuery('.indicator-container');
    container.load(container.data('url'));
  },


  indicator_value_show_all: function() {
    var content = jQuery(".main .content");
    content.css('height', 'calc(100vh - ' + content.position().top + 'px)')

    var container = jQuery('.indicator-container');
    container.load(container.data('url'));
  },


  support_questions: function() {
    // SUPPORT CASES
    var options = {
      sort: true,
      info: false,
      lengthChange: false,
      paging: true,
      pageLength: 10,
      autoWidth: false,
      filter: false,
      order: [[4, 'asc']],
      columnDefs: [
      {
        targets: 0,
        visible: false
      },
      {
        targets: 1,
        data: function ( row, type, val, meta ) {
          if (type === 'display') {
            var link = SmartME.linkToModal(
              row[1], 
              monitoring_show_support_case_path({'support_case_id': row[0], format: 'html'}),
              {buttons: false, title: row[1]});
            return $('<div>').append(link).html();
          }

          return row[1];
        }
      },
      {
        targets: 7,
        sortable: false,
        visible: $('thead th.close-support-case').length > 0, // Skip the column if it is not present in the header
        data: function ( row, type, val, meta ) {
          if (type === 'display') {
            if ($(meta.settings.nTable).is('#open-support-cases')) {
              var link = $('<a>').attr('href', '#').text(I18n.t('close'));
              link.attr('data-support-case-id', row[0]);
              link.addClass('update-support-case-status btn btn-default pull-right');
              return $('<div>').append(link).html();
            }
          }

          return '';
        }
      },
      {
        targets: 4,
        data: function ( row, type, val, meta ) {
          if (type === 'display') {
            return row[4].label;
          }
            
          return row[4].order;
        }
      },
      {
        targets: 5,
        data: function (row, type, val, meta) {
          if (type === 'display') {
            return row[5].label;
          }

          return row[5].order;
        }
      }]
    };

    $('#open-support-cases').dataTable($.extend({}, options, {data: $('#open-support-cases').data('table-content')}));
    $('#closed-support-cases').dataTable($.extend({}, options, {data: $('#closed-support-cases').data('table-content')}));

    $('#submit-support-case-button').on('click', function() {
      $.ajax({
        url: monitoring_create_support_case_path({project_id: $(this).data('project-id')}),
        method: 'POST',
        data: $(this).closest('form').serialize()
      }).done(function(response){
        var api = $('#open-support-cases').DataTable();
        var row = api.row.add(response).draw().node();
        $(row).addClass('new');
        $('#submit-support-case-button').closest('form')[0].reset();
        $('#new-question').hide();
      });

      return false;
    });

    $('body').delegate('.update-support-case-status', 'click', function() {
      if (confirm(I18n.t('confirm_close_support_case'))) {
        var link = $(this);
        $.ajax({
          url: monitoring_update_support_case_status_path({
            'support_case_id': $(this).data('support-case-id'),
            status: 'closed'
          }),
          method: 'POST'
        }).done(function(response){
          link.closest('td').text(response.text);
        });
      }
      return false;
    });


    $('#new-question-button').on('click', function() {
      $('#new-question').toggle();
      return false;
    });

  },


  indicator_list: function() {
    jQuery('.timeline-end-selector').on('change', function() {
      window.location.href = jQuery(this).data('url').replace('__end__', jQuery(this).val());
    });

    jQuery('table.indicator-values').on('click', '.toggle-disaggregation', function(e) {
      var el = jQuery(e.currentTarget);
      var rootId = el.closest('tr').data('id');
      var state = JSON.parse(sessionStorage.getItem('smart-me-monitoring-toggle') || '{}');

      el.find('.toggle-indicator').toggleClass('open');
      el.closest('table').find('tr[data-root-id="' + rootId + '"]').toggle();
      state[rootId] = el.find('.toggle-indicator').is('.open');
      sessionStorage.setItem('smart-me-monitoring-toggle', JSON.stringify(state));

      return false;
    });

    // Update state from session storage
    var state = JSON.parse(sessionStorage.getItem('smart-me-monitoring-toggle') || '{}');
    Object.keys(state).forEach(function(rootId) {
      if (state[rootId]) {
        jQuery('table.indicator-values tr[data-id="' + rootId + '"] .toggle-disaggregation').trigger('click');
      }
    });

    // Tooltips
    jQuery('.indicator-values').find('.progress, .label.disaggregation, .link-count').tooltip();
  },

  info: function(){
    ActionJS.Applicant._collapseHighlight();

    $('.monitoring-sub-menu-static').on('click', function(){
      $(this).closest('ul').find('li').removeClass('active');
      $(this).find('li').addClass('active');

      // ReactRailsUJS.unMountComponents();
      $('div.sub-content').html(
        $(this).find('.static-content').html()
        );
      // ReactRailsUJS.mountComponents();
    })
  },

  faq: function(){
    jQuery('.faq .faq-question').on('click', function (e) {
      jQuery(this).toggleClass('active');
      e.preventDefault();
      jQuery(this).closest('.faq-content').find('.faq-answer').toggleClass('hidden');
      jQuery(this).closest('.faq-content').find('i').toggleClass('faq-arrow-down');

      return false;
    })
  },

  project_info: function() {
    jQuery('body').undelegate('.enable-editor', 'click');
    jQuery('body').delegate('.enable-editor', 'click', function(e) {
      var $link = jQuery(this);
      jQuery.ajax({
        url: $link.attr('href'),
        method: 'post'
      }).done(function(data) {
        $link.toggleClass('locked');
        $link.find('i').toggleClass('fa-lock', $link.is('.locked'));
        $link.find('i').toggleClass('fa-unlock', !$link.is('.locked'));
        $link.attr('href', $link.attr('href').replace(/(true|false)$/, ($link.is('.locked') ? 'true' : 'false')))
      });

      return false;
    });
  },


  indicator_value_show: function() {
    // Tooltips
    jQuery(".indicator-tooltip").tooltip();
  },


  record_value: function() { //old unsed functionality for capturing indicator values
    ActionJS.Monitoring.indicator_value_show();
    // ReactRailsUJS.mountComponents('[data-react-class="indicator_record/ExternalEntityInput"]');
    var initPickers = function(){
      // old picker
      //jQuery('#modal-dialog .date').datetimepicker({format: "YYYY-MM-DD", widgetPositioning: {vertical: 'auto'}});
      // #TODO: Test before use.
      jQuery('#modal-dialog .date').flatpickr({dateFormat: "Y-m-d", static: true, allowInput: true});
      jQuery('#modal-dialog .open-datepicker').on('click', function() {
        jQuery(this).closest('.input-group').find('.date').focus();
      });
    }

    initPickers();
    jQuery('body').off('click', '.add-new-row').on('click', '.add-new-row', function(){
      var newRow = jQuery('#new-record-row-template').clone().html();
      jQuery($(this).closest('tr')).after(newRow);
      initPickers();
      initDropzones();
      // ReactRailsUJS.mountComponents();
     });

    jQuery('body').off('click', '.remove-new-row').on('click', '.remove-new-row', function(){
      if (jQuery('.remove-new-row').length > 1){ // Don't allow deleting the only row
        var trToBeRemoved = jQuery($(this).closest('tr'));
        // ReactRailsUJS.unmountComponents(trToBeRemoved.find('[data-react-class="indicator_record/ExternalEntityInput"]').get(0));
        jQuery(this).closest('tr').remove();
      }
    });

    var adjustTextareaHeight = function() {
      if (this.scrollHeight > 0) {
          jQuery(this).innerHeight(0);
          jQuery(this).innerHeight(this.scrollHeight);
      }
    }

    jQuery('.auto-textarea').each(adjustTextareaHeight);
    jQuery('body').on('input', '.auto-textarea', adjustTextareaHeight);


    // File upload
    var initDropzones = function() {
      jQuery('.indicator-value-upload').each(function(i, zone) {
        var zone = jQuery(this);

        // Init if not initialized
        if (!zone.hasClass('dz-clickable')) {
          var dz = new Dropzone(zone.get(0), {
            url: zone.data('upload-url'),
            headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
            dictDefaultMessage: I18n.t('attachment_drop_multiple_instruction'),
            addRemoveLinks: true,
            dictRemoveFile: ''
          });
          dz.on('addedfile', function(file) {
            zone.find('.dz-preview').last().append('<input type="hidden" name="values[][files[' + zone.attr('data-upload-id') + '][new]][]" value="' + file.name + '" />');
          });
          
          // Correct the position of the old files to bottom of the zone and handle delete
          zone.find('.dz-preview').appendTo(zone).on('click', 'a.delete-file', function(event) {
            var link = jQuery(event.currentTarget);
            link.closest('.dz-preview').remove();
            return false;
          });
        }
      });
    }
    
    initDropzones();
  },


  /**
   * @param  {String} type type of indicator to find. should be 'indicator' or 'activity'
   */
  show_indicator_value: function(type) {
    jQuery('#indicator-value-date-select').on('change', function() {
      // ie compatible default param.
      type = typeof type !== 'undefined' ? type : 'indicator';
      url = "";
      val = jQuery(this).val();

      if (type == 'indicator') {
        url = indicator_value_show_path({indicator_value_id: val});
      } else if ( type == 'activity') {
        url = indicator_value_show_activity_path({activity_status_id: val})
      } else {
        alert(I18n.t('something_went_wrong'))
        
        return
      }

      openModalDialog({
        title: I18n.t('indicator_value'),
        modalClass: 'modal-lg',
        hideButtons: true,
        url: url
      });
    });
  },


  support_requests: function () {
    var table = jQuery("#support-request-table");

    var order_by = DataTablesHelper.colIndex(table, 'created_at');

    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery('#list-data').html()),
      info: true,
      lengthChange: false,
      pageLength: 20,
      order: [[order_by == null ? 0 : order_by, 'desc']],
      autoWidth: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      initComplete: function () {
          DataTablesHelper.setAutoComplete(table);
      },
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == 'display') {
              return jQuery('#task-link-template').html().
                replace(/__identifier__/g, data.identifier).
                replace(/__save_label__/g, data.save_label).
                replace(/__identifier_link__/g, encodeURIComponent(data.identifier));
            } else if (type == 'sort') {
              return data.sort;
            }
            return data.identifier;
          },
          type: 'num', // type for sorting
          targets: [DataTablesHelper.colIndex(table, 'id')]
        },
        {
          render: function (data, type) {
            if (!data) return '';
            if (type === 'display') return data.label ?? '';
            if (type === 'sort') return data.sort ?? '';
            return data.status ?? '';
          },
          targets: [DataTablesHelper.colIndex(table, 'status')]
        },
        {
          render: function (data, type, row, meta) {
            if (type == 'display') {
              return jQuery('#assignee-template').html().
                replace(/__identifier_link__/g, encodeURIComponent(data.identifier)).
                replace(/__id__/g, data.id).
                replace(/__assignee__/g, data.assignee);
            } else if (type == 'filter') {
              return data.assignee_id
            }
            return data.assignee;
          },
          orderable: false,
          targets: [DataTablesHelper.colIndex(table, 'assignee')]
        },
        {
          render: function(data, type, row, meta) {
            if (type == 'display') {
              return data.label;
            }
            return data.sort;
          },
          targets: [DataTablesHelper.colIndex(table, 'created_at')]
        }
      ],
      drawCallback: function () {
        DataTablesHelper.addColumnFilters(this);
        ActionJS.Task._assign(true);
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    table.DataTable(options);
  },

  show_support_request: function (requestId, status) {
    jQuery('.modal-footer .btn-primary').on('click', function (e) {
      e.stopPropagation();
      if (confirm(I18n.t('confirm_update_support_request_status', {status: status == 'done' ? 'closed' : 'open'}))) {
        jQuery.ajax({
          url: support_request_update_status_path({support_request_id: requestId, status: status}),
          method: 'POST',
          headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content') },
        }).done(function (d) {
          jQuery('#modal-dialog', top.document).modal('hide');
          Turbo.visit(window.location.href);
        });
      } 
      e.preventDefault();
    });

    jQuery('.support-request-form').each(function () {
      var formContainer = jQuery(this);
      SmartME.setLoadingIndicator(formContainer);
      formContainer.load(formContainer.attr('data-url'), function () {
        if (formContainer.find('.adalia-form').length > 0) {
          AdaliaForm.init(formContainer);
        }
      });
    });
  },

  user_management: function () {
    ActionJS.User.programme_list();
	},

  priv: {
    initPhaseProgressGadget: function(phaseId) {
      ActionJS.Monitoring.priv.initPhaseProgressChart(phaseId);

      jQuery('.phase-progress-select').on('change', function() {
        var phases = JSON.parse(jQuery(this).val());
        var started = JSON.parse(jQuery('select.phase-progress-select').val()).map(function(v,k) {if (v.started) return v;}).clean(undefined);
        var phaseId = started[started.length-1].id;
        ActionJS.Monitoring.priv.initPhaseProgressChart(phaseId);
        ActionJS.Monitoring.priv.updatePhaseProgressTitles();
      });
      jQuery('.phase-progress-select');

      jQuery('.dashboard-widget').delegate('ul.phase-titles .next-phase', 'click', function(e) {
        var $next = jQuery(this).closest('li').next('li')
        if ($next.length > 0) {
          $next.siblings('li').removeClass('active');
          $next.addClass('active');
          ActionJS.Monitoring.priv.initPhaseProgressChart($next.data('phase-id'));
        }
        e.preventDefault();
        return false;
      });
      jQuery('.dashboard-widget').delegate('ul.phase-titles .prev-phase', 'click', function(e) {
        var $prev = jQuery(this).closest('li').prev('li')
        if ($prev.length > 0) {
          $prev.siblings('li').removeClass('active');
          $prev.addClass('active');
          ActionJS.Monitoring.priv.initPhaseProgressChart($prev.data('phase-id'));
        }
        e.preventDefault();
        return false;
      });
    },

    initPhaseProgressChart: function(phaseId) {
      if (phaseId == '') {
        $('<li>' + I18n.t('no_phases_defined') + '</li>').appendTo('ul.phase-titles').show();
        return;
      }
      jQuery.getJSON(monitoring_dashboard_phase_progress_data_path({phase_id: phaseId}), function(chartData) {
        // replace the canvas to prevent a glitch in chartjs hover
        if (ActionJS.Monitoring.phaseProgressChart) ActionJS.Monitoring.phaseProgressChart.destroy();
        var $old = jQuery('canvas#phase-progress-chart');
        var $elem = jQuery(jQuery('<div>').append(jQuery('canvas#phase-progress-chart').clone()).html());
        $elem.insertAfter($old);
        $old.remove();
        $elem.siblings('.loading-indicator').remove();
        $elem.show();

        ActionJS.Monitoring.phaseProgressChart = new Chart($elem[0], {
          type: 'bar',
          data: chartData,
          options: {
            tooltips: {
              mode: 'index',
              enabled: true,
              callbacks: {
                label: function(tt, data) {
                  return (tt.yLabel + '');
                }
              }
            },
            scales: {
              xAxes: [{
                stacked: true,
                ticks: {
                  autoSkip: false
                }
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        });
      });
    },

    updatePhaseProgressTitles: function() {
      var $titles = jQuery('.phase-titles');
      $titles.html('');
      var phases = JSON.parse(jQuery('select.phase-progress-select').val());
      jQuery.each(phases, function(k,phase) {
        var $li = jQuery('<li>').data('phase-id', phase.id);
        if (phases[k-1]) {
          var $icon = jQuery('<i>').addClass('fa fa-chevron-left');
          var $prevPhaseLink = jQuery('<a>').attr('href', '#').addClass('prev-phase').html($icon);
          $li.append($prevPhaseLink);
        }
        $li.append(phase.name);
        if (phases[k+1]) {
          var $icon = jQuery('<i>').addClass('fa fa-chevron-right');
          var $nextPhaseLink = jQuery('<a>').attr('href', '#').addClass('next-phase').html($icon);
          $li.append($nextPhaseLink);
        }

        if (phase.started) {
          $li.addClass('active');
        }

        $titles.append($li);
      });

      var $active = (jQuery('.phase-titles li.active').length > 0 ? jQuery('.phase-titles li.active').last() : jQuery('.phase-titles li').first());
      jQuery('.phase-titles li').removeClass('active');
      $active.addClass('active');
    },

    initStatusGadget: function(callId) {
      jQuery.getJSON(monitoring_dashboard_call_status_data_path({call_id: callId}), function(data) {
        ActionJS.Monitoring.priv.initStatusChart(data.bars);
        // ActionJS.Monitoring.priv.initStatusTable(data.projects || []);
      });

      jQuery('.call-status-select').on('change', function() {
        jQuery.getJSON(monitoring_dashboard_call_status_data_path({call_id: jQuery(this).val()}), function(data) {
          ActionJS.Monitoring.priv.initStatusChart(data.bars);
          ActionJS.Monitoring.callProjectTable.destroy();
          // ActionJS.Monitoring.priv.initStatusTable(data.projects || []);
        });
      });
      jQuery('.call-status-select');
    },

    // initStatusChart: function(chartData) {
    //   // replace the canvas to prevent a glitch in chartjs hover
    //   if (ActionJS.Monitoring.callStatusChart) ActionJS.Monitoring.callStatusChart.destroy();
    //   var $old = jQuery('canvas#call-status-chart');
    //   var $elem = jQuery(jQuery('<div>').append(jQuery('canvas#call-status-chart').clone()).html());
    //   $elem.insertAfter($old);
    //   $old.remove();
    //   $elem.siblings('.loading-indicator').remove();
    //   $elem.show();
    //   ActionJS.Monitoring.callStatusChart = new Chart($elem[0], {
    //     type: 'bar',
    //     data: chartData,
    //     options: {
    //       scales: {
    //         xAxes: [{
    //           stacked: true,
    //           ticks: {
    //             autoSkip: false
    //           }
    //         }],
    //         yAxes: [{
    //           stacked: true
    //         }]
    //       },
    //       tooltips: {
    //         mode: 'index'
    //       }
    //     }
    //   });
    // },

    initStatusTable: function(projects) {
      if (!jQuery.fn.DataTable.isDataTable('#call-status-projects')) {
        ActionJS.Monitoring.callProjectTable = jQuery('#call-status-projects').DataTable({
          data: projects,
          pageLength: 15,
          autoWidth: false,
          lengthChange: false,
          filter: false,
          columnDefs: [
            {
              render: function(data, type, row, meta) {
                  if (type == 'display') {
                    var projectId = row[row.length - 1].id;
                    var link = jQuery('<a>').attr('href', monitoring_info_path({'project_id': data.id, format: null})).
                      text(data.title);
                    return jQuery('<div>').append(link).html();
                  }
                  return data;
              },
              targets: 0
            }
          ]
        });
      }
    },

    updateVisibleColumns: function (e) {
      var elem = jQuery(this);

      if (elem.is('input')) {
        var dropdown = elem.closest('.variable-columns');
        var index = parseInt(elem.attr('data-index'), 10);
        var visible = elem.prop('checked');
        var colTypes = dropdown.data('col-types');
        var visible_cols = [];
        var hidden_cols = []
        dropdown.find('input').each(function () {
          var isStatic = jQuery(this).data('col-type') == colTypes.static;
          if (this.checked && !isStatic) {
            visible_cols.push(this.value);
          } else if (!this.checked && isStatic) {
            hidden_cols.push(this.value);
          }
        });

        ActionJS.Monitoring.priv.projectTable.column(index).visible(visible);
        ActionJS.Monitoring.priv.projectTable.draw();
        jQuery.post(dropdown.attr("data-url"), { hidden_cols: hidden_cols, visible_cols: visible_cols });
      } else {
        elem.find('input').trigger('click');
        return false;
      }

      e.stopPropagation();
    },

    getHiddenColumns: function () {
      var hiddenColumns = [];
      jQuery('.dropdown.variable-columns input:not(:checked)').each(function () {
        hiddenColumns.push(parseInt(this.getAttribute('data-index'), 10));
      });
      return hiddenColumns;
    },
  }
};






// functionality defined before ActionJS
  var bindPaymentResultButtonRemove = function(button) {
    button.on('click', function() {
      if (confirm($(this).data('confirm-message'))) {
        $(this).closest('.payment-result-row').remove();
      }
    });
  }
  var bindPaymentMilestoneButtonRemove = function(button) {
    button.on('click', function() {
      if (confirm($(this).data('confirm-message'))) {
        $(this).closest('.payment-milestone-row').remove();
      }
    });
  }


  var bindPaymentResultOptionDisabler = function() {
    $('select[name^="payment[payment_results]"]').off('change').on('change', function(){
      disableResultSelectOptions();
    });
    disableResultSelectOptions();
  }

  var disableResultSelectOptions = function() {
    var $selects = $('select[name^="payment[payment_results]"]');
    var selectedResults = $selects.map(function(i,e){return $(e).val()});
    $selects.find('option').removeAttr('disabled');
    $.each(selectedResults, function(i,v){
      $selects.find('option[value="'+v+'"]').attr('disabled', 'disabled');
      $selects.find('option[value="'+v+'"]:selected').removeAttr('disabled');
    });

    $selects.select2('destroy').select2({
      formatResult: SmartME.formatResultSelect2,
      formatSelection: SmartME.formatTitleSelect2 });
  }

  var bindPaymentMilestoneOptionDisabler = function() {
    $('select[name^="payment[payment_milestones]"]').off('change').on('change', function(){
      disableMilestoneSelectOptions();
    });
    disableMilestoneSelectOptions();
  }

  var disableMilestoneSelectOptions = function() {
    var $selects = $('select[name^="payment[payment_milestones]"]');
    var selectedMilestones = $selects.map(function(i,e){return $(e).val()});
    $selects.find('option').removeAttr('disabled');
    $.each(selectedMilestones, function(i,v){
      $selects.find('option[value="'+v+'"]').attr('disabled', 'disabled');
      $selects.find('option[value="'+v+'"]:selected').removeAttr('disabled');
    });

    $selects.select2('destroy').select2();
  }


  // INITIALIZE
  var initialize = function() {
    var resultsFrameworkTarget = $('.content.results-framework');

    if (resultsFrameworkTarget.length > 0) {
      $.ajax({
        url: result_framework_show_path({
          project_id: resultsFrameworkTarget.data('project-id'),
          result_framework_id: resultsFrameworkTarget.data('result-framework-id'),
          version: resultsFrameworkTarget.data('version'),
          format: 'html'}),
        async: true
      }).done(function(content) {
        resultsFrameworkTarget.html(content);
      });
    }

    var milestonesTarget = $('.milestones-container');

    if (milestonesTarget.length > 0) {
      $.ajax({url: project_milestone_list_path({'project_id': milestonesTarget.data('project-id'), format: 'html'}), async: true})
        .done(function(content) {
          milestonesTarget.html(content);
        });
    }
    var filesTarget = $('.files-container');

    if (filesTarget.length > 0) {
      $.ajax({url: list_project_files_path({'project_id': filesTarget.data('project-id'), format: 'html'}), async: true})
        .done(function(content) {
          filesTarget.html(content);
        });
    }

    $('a.monitoring-sub-menu-link').on('click', function() {
      var a = $(this);
      a.closest('ul').find('li').removeClass('active');
      a.find('li').addClass('active');
      return false;
    });

    $(document).on('mousedown', '.monitoring-open-project-data-sheet-form-version-selector', function(e) {
      e.stopImmediatePropagation();

      $.ajax({url: monitoring_project_info_path({
        programme_form_link_id: $(this).data('programme-form-link-id'),
        project_id: $(this).data('project-id'),
        form_version: $(this).data('version') || '',
        format: 'html'
        })})
      .done(function(content){
        $('div.sub-content').html(content);
      });
      $('div.monitoring-open-project-info-data-sheet-form').html(SmartME.loadingIndicator());
      return false;
    });

    $(document).on('mousedown', '.monitoring-open-project-data-sheet-version-selector', function(e) {
      e.stopImmediatePropagation();

      $.ajax({url: monitoring_project_info_path({
        project_id: $(this).data('project-id'),
        project_version: $(this).data('version') || '',
        format: 'html'
      })})
      .done(function(content){
        $('div.sub-content').html(content);
      });
      $('div.monitoring-open-project-info-data-sheet').html(SmartME.loadingIndicator());
      return false;
    });

    $(document).on('mousedown', '.monitoring-sub-menu-link.monitoring-open-additional-info-form', function(e) {
      e.stopImmediatePropagation();

      $.ajax({url: programme_form_show_path({
        programme_form_link_id: $(this).data('programme-form-link-id'), 
        format: 'html', 
        entity_type: 'project_additional_info', 
        entity_id: $(this).data('project-id'), 
        editable: false,
        submit_status: 'submitted',
        version: $(this).data('version') || '',
        submit_redirect: monitoring_info_path({'project_id': $(this).data('project-id')})
      })})
        .done(function(content){
          $('div.sub-content').html(content);
        });
      $('div.sub-content').html(SmartME.loadingIndicator());
      return false;
    });

    // END OF TODO
    var menu = jQuery('a.monitoring-sub-menu-link').closest('.content-menu');
    if (menu.length > 0) {
      var link = menu.find('.' + menu.data('active'))
      // if (link.data('url')) {
      //   link.find('li').addClass('active');
      //   $.ajax({ url: link.data('url') })
      //     .done(function (content) {
      //       $('div.sub-content').html(content);
      //       $(window).trigger('formLoaded');
      //     });

      //   $('div.sub-content').html(SmartME.loadingIndicator());
      // } else {
        if ('monitoring-open-additional-info-form'.includes(menu.data('active'))) link.trigger('mousedown');
        link.trigger('click');
      // }
    }

    // sub-content should take the document's width
    if ($('.sub-content').length > 0) {
      $('.sub-content').css('min-height', $(document).height() - $('.sub-content').offset().top);
    }

    $('.indicator-value-row').on('progress-update', function(ev, args) {
      $(this).attr('data-indicator-value-id', args.new_id);
      var link = $(this).find('a.new-indicator-value');
      var bar = $(this).find('.progress-bar');
      var min = bar.attr('aria-valuemin'); 
      var max = bar.attr('aria-valuemax');

      bar.attr('aria-valuenow', args.value);

      // update progress bar
      var percentage = ((args.value - min) / (max-min) * 100);
      bar.css({'width': percentage + '%', 'background-color': 'hsl('+ percentage/100*120 + ', 29%, 60%)'});
      var progressValue = bar.find('.progress-value');
      progressValue.attr('title', percentage + ' %');
      SmartME.animateDecimal(parseInt(progressValue.text()), args.value, 1000, function(v){progressValue.text(Math.round(v));})

      // update date
      $(this).find('.next-update-date input.form-control').val(args.next_update_date);

      // developer
      $(this).find('.developer-name-field').html(args.developer.name);

      // update new link
      link.attr('href', monitoring_edit_indicator_value_path({'indicator_value_id': args.new_id, 'format': 'html'}));
    });

    $('.next-update-date').flatpickr({dateFormat: 'Y-m-d', allowInput: true});
    $('.next-update-date').on('change', function() {
      var dateContainer = $(this);
      $.ajax({
        url: monitoring_update_indicator_value_date_path({'indicator_value_id': $(this).closest('.indicator-value-row').data('indicator-value-id')}),
        type: 'post',
        data: {'next_date': $(this).find('input.form-control').val()}
      }).done(function() {
        dateContainer.find('.saved-indicator').removeClass('hidden');
        dateContainer.find('.calendar-icon').addClass('hidden');
        setInterval(function() {
          dateContainer.find('.saved-indicator').addClass('hidden');
          dateContainer.find('.calendar-icon').removeClass('hidden');
        }, 3000);
      }).error(function(){
        dateContainer.find('.error-indicator').removeClass('hidden');
        dateContainer.find('.calendar-icon').addClass('hidden');
        setInterval(function() {
          dateContainer.find('.error-indicator').addClass('hidden');
          dateContainer.find('.calendar-icon').removeClass('hidden');
        }, 3000);
      });
    });

    $('.activity-discussion-toggle').on('click', function() {
      $(this).closest('.discussion-container').find('.adalia-discussion').slideToggle(400);
      return false;
    });

    // sortings
    // $('[data-sort-by]').on('click', function() {
    //   var icon = $(this).find('.sort-icon');
    //   var allIcons = $('[data-sort-by] .sort-icon');
    //   allIcons.removeClass('glyphicon-sort-by-attributes-alt glyphicon-sort-by-attributes');
    //   allIcons.addClass('glyphicon-sort');
    //
    //   if ($(this).hasClass('sorting-desc')) {
    //     $(this).removeClass('sorting-desc');
    //     $(this).addClass('sorting-asc');
    //     icon.addClass('glyphicon-sort-by-attributes');
    //     var direction = 'asc';
    //   } else {
    //     $(this).removeClass('sorting-asc');
    //     $(this).addClass('sorting-desc');
    //     icon.addClass('glyphicon-sort-by-attributes-alt');
    //     var direction = 'desc';
    //   }
    //
    //   var sortBy = eval('('+ $(this).data('sort-function')+ ')');
    //   sortMonitoringList('.list-row ' + $(this).data('sort-by'), sortBy, direction);
    // });

    // payment modal dialog initialization
    $(document).on('modal:loaded, modal:updated', '#modal-dialog', function() {
      // payment result 
      $(this).find('button.new-payment-result').on('click', function() {
        var uniqueId = SmartME.generateUniqueId();
        var modal = $(this).closest('.modal-body');
        var template = modal.find('.payment-result-template');
        template.find('select.select2').select2('destroy');
        var paymentResultContainer = modal.find('.result-link-container');
        var newRow = $(template.html().replace(/\$randomId/g, uniqueId));
        newRow.find('.select2').select2({
          formatResult: SmartME.formatResultSelect2,
          formatSelection: SmartME.formatTitleSelect2
        });
        bindPaymentResultButtonRemove(newRow.find('button.remove-payment-result'));
        paymentResultContainer.append(newRow);
        bindPaymentResultOptionDisabler();
      });
      bindPaymentResultButtonRemove($(this).find('button.remove-payment-result'));

      $(this).find('button.new-payment-milestone').on('click', function() {
        var uniqueId = SmartME.generateUniqueId();
        var modal = $(this).closest('.modal-body');
        var template = modal.find('.payment-milestone-template');
        template.find('select.select2').select2('destroy');
        var paymentMilestoneContainer = modal.find('.milestone-link-container');
        var newRow = $(template.html().replace(/\$randomId/g, uniqueId));
        newRow.find('.select2').select2();
        bindPaymentMilestoneButtonRemove(newRow.find('button.remove-payment-milestone'));
        paymentMilestoneContainer.append(newRow);
        bindPaymentMilestoneOptionDisabler();      
      });
      bindPaymentMilestoneButtonRemove($(this).find('button.remove-payment-milestone'));

      // on select2 change
      bindPaymentResultOptionDisabler();
      bindPaymentMilestoneOptionDisabler();
    });

  }

  // selector: '.list-row .next-update-date input'
  // sortingFunction: function(i,e) {return $(e).val();})
  // function sortMonitoringList(selector, sortingFunction, direction) {
  //   var sortedValues = jQuery(selector).map(sortingFunction).get();
  //   sortedValues.sort();
  //
  //   if (direction == 'desc') {
  //     sortedValues.reverse();
  //   }
  //
  //   jQuery(selector).each(function(i,e){
  //     var nextVal = sortedValues.shift();
  //     jQuery(selector).each(function(i2,e2){
  //       if (sortingFunction(null, e2) == nextVal) {
  //         jQuery(e2).closest('.list-row').appendTo('.indicator-container');
  //       }
  //     });
  //   });
  // }

  function generateUniqueId() {
    var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = 'id'; // To have it begin with letter
    for (var i = 0; i < 6; i++) {
        var randomPos = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPos, randomPos + 1);
    }
    return randomString;
  }

window.legacyMonitoringInit = initialize;